import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {SortableContainer, SortableElement, SortableHandle, arrayMove} from 'react-sortable-hoc';
import FontAwesome from 'react-fontawesome';
import firebase from 'firebase/app';
import 'firebase/database';

/** @class HallBoothsList
  * A component which lists the booths of a hall.
  */
export default class BoothOrder extends Component {
  /** @constructor
    * Constructs a new HallBoothsList instance
    */
  constructor(props) {
    super(props);
    this.handleSortEnd = this.handleSortEnd.bind(this);
    this.handleAutoArrange = this.handleAutoArrange.bind(this);
  }
  /** @method toggleBoothSelectionDialog
    * Shows or hides the booth selection dialog
    */
  toggleBoothSelectionDialog() {
    this.setState({showSelectDialog: !this.state.showSelectDialog})
  }
  /** @method handleSortEnd
    * Applies user-sorting to the booth list.
    * @param {Object} {oldIndex, newIndex} the
    * two items to swap in the booth list.
    */
  handleSortEnd({oldIndex, newIndex}){
    var booths = arrayMove(this.props.boothList, oldIndex, newIndex);
    var updates = {}
    booths.forEach((booth, i) => {
      updates[`${this.props.dataURL}/${booth.id}/order`] = i + 1;
    });
    firebase.database().ref().update(updates);
  }
  handleAutoArrange() {
    var updates = {}
    var oldX = 0, newX = 0, y = 0;
    var booths = this.props.boothList;
    booths.forEach(booth => {
      // Try placing booth in current column
      if(y + booth.height < this.props.height) {
        updates[`${this.props.dataURL}/${booth.id}/x`] = oldX;
        updates[`${this.props.dataURL}/${booth.id}/y`] = y;
        if(oldX + booth.width > newX) newX = oldX + booth.width;
        y = y + booth.height;
      } else {
        // Move to next column
        oldX = newX;
        newX = oldX + booth.width;
        y = 0;
        updates[`${this.props.dataURL}/${booth.id}/x`] = oldX;
        updates[`${this.props.dataURL}/${booth.id}/y`] = y;
      }
    });
    firebase.database().ref().update(updates);
  }
  /** @method render
    * Renders the component.
    */
  render() {
    return '';
    // TODO: Booth reordering is broken!!!!
    return (
      <div className="hall-booth-list">
        <button className="big-button caution-color" onClick={this.handleAutoArrange}>
          Auto Arrange Booths
        </button>
        <h3>Reorder</h3>
        <SortableList
          dataURL={this.boothURL}
          items={this.props.boothList}
          useDragHandle={true}
          onSortEnd={this.handleSortEnd}
          />
      </div>
    );
  }
}

/* A Drag handle for the sortable list */
const DragHandle = SortableHandle(() => <FontAwesome name="reorder"/>);

/* An item in the sortable list */
const SortableListItem = SortableElement((props) => {
  return(
    <div className="sortable-list-item">
      <DragHandle />
      {props.booth.name}
      <span>
        <Link to={props.dataURL}>
          <FontAwesome name="edit"
            style={{color:"#965ba5", cursor:"pointer"}}/>
        </Link>
      </span>
    </div>
  );
});

/* The sortable list */
const SortableList = SortableContainer((props) => {
  return (
    <div className="sortable-list">
      {props.items.map((booth, index) => (
        <SortableListItem
          key={booth.id}
          index={index}
          booth={booth}
          dataURL={`${props.dataURL}/${booth.id}`}
          />
      ))}
    </div>
  );
});



// WEBPACK FOOTER //
// ./src/hall-editor/booth-order.js